import LocalizedStrings from 'localized-strings/lib/LocalizedStrings';

const Strings = new LocalizedStrings({
    en: {
        menu: {
            contentLibrary: 'Content Library',
            myStudents: 'My Students',
            allStudents: 'All Students',
            curriculumBuilder: 'Curriculum Builder',
            logout: 'Logout',
            search: 'Search',
            welcome: 'Welcome',
            newUser: 'New User',
            reporting: 'Reporting',
            manage: 'Manage',
            myStudents: 'My Students',
            offers: 'Offers',
            vendors: 'Vendors',
            contentBuilder: 'Content Builder',
            users: 'Users',
            scoreReport: 'Score Distribution Report',
            resources: 'Resources',
            licenceeMark: 'Official LSAT Content Licensee Mark'
        }
    },
    fr: {
        menu: {
            contentLibrary: 'Bibliothèque de contenu',
            myStudents: 'Mes étudiants',
            allStudents: 'Tous les étudiants',
            curriculumBuilder: "Programme d'études Constructrice",
            logout: 'Se déconnecter',
            search: 'Chercher',
            welcome: 'Bienvenu',
            newUser: 'Nouvel utilisateur',
            reporting: 'Rapports',
            manage: 'faire en sorte',
            myStudents: 'Mes étudiants',
            offers: 'des offres',
            vendors: 'Vendeurs',
            contentBuilder: 'Générateur de contenu',
            users: 'utilisateurs',
            scoreReport: 'Rapport de distribution des scores',
            resources: 'Ressources',
            licenceeMark: 'Marque de licence officielle du contenu LSAT'
        }
    }
});

export default Strings;
